<template>
  <!--
    ********************************************************
    ****   FORMATO NUMERO 10 CARRUSEL                   ****
    ****                                                ****
    ********************************************************
  -->
<div class="row">

    <div class="col-12" v-for="(contenido,index) in contenidos" :key="index">
              <h3 class="tituloCarrusel">{{contenido.TextoDelContenido}}</h3>
        <div class="contenedor-carousel" >
        <carousel :autoplay="carruselAutoPlay(contenido.CarruselDeMicrositios)" :responsive="itemsCarrusel(contenido.CarruselDeMicrositios)" > 
             <div v-for="(item,index2) in contenido.ArchivosDeContenidoMicrositios" :key="index2">
            <div class="contenedor-imagenes" style="position:relative">
            <img class="imagenDeCarrusel" v-bind:src="RutaDeImagen(item.RutaDelArchivo)" alt="imagen" /> 
           
            <div v-if="validaTexto(item.Titulo) || validaTexto(item.TextoDescripcion)|| validaTexto(item.TextoLink)" class="caja-texto">
              <h1 class="text-center titulo">{{item.Titulo}}</h1>
              <h2 class="texto-descripcion">{{item.TextoDescripcion}}</h2>
              <h2 class="text-right vinculo"><a v-if="item.AbrirEnVisor == false && item.AbrirEnVisor !=null" @click="AbrirArchivo(item.ArchivoAdicionalCarpeta,'_self')">{{item.TextoLink}}</a></h2>
            <h2 class="text-right vinculo"> <a v-if="item.AbrirEnVisor" @click="AbreElVisor(item.ArchivoAdicional)">{{item.TextoLink}}</a></h2>
              </div>
              </div>
              </div>
          </carousel>
                  </div>
    </div>

</div>
</template>


<script>
 import carousel from 'vue-owl-carousel'
 import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
 import comun from "@/../static/js/comun";

export default {
   data: function(){
     return{
      autoPlay: false,
      RUTA_LOCAL:"\\\\themisfs",
      enumeraciones_sicpo
     }
       
    },
    props:{
        contenidos:Array
    },
    
    components:{
        carousel
    },
    methods:{
      validaTexto(texto){
        let valido=true;
        if(texto==null||texto.length==0 || texto=="")
          valido=false
        return valido;
      },
      RutaDeImagen(imagen){
       
          return imagen.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
      },
  AbrirArchivo: function(vinculo,forma) {
    //console.log("abrirarchivo:::",vinculo)
  if(vinculo!=null){
     // if(vinculo.includes(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos) || vinculo.includes(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos)){
       //   var rutaDeDescarga = vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
          //window.open(rutaDeDescarga,forma);
         // console.log("abrirarchivo22222:::",vinculo)
          comun.DescargarDocumentoPDF(vinculo);
     // }
  }
        },
        AbreElVisor: function(vinculo) {
        //  console.log("abre visor ::: ",vinculo);
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
      rutaDeDescarga:function(archivo){
        var cadena =(archivo!=null)? archivo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos):archivo;
          return cadena
      },
        itemsCarrusel:function(elemento){               
                var opciones ={0:{items:elemento.Elementos00,nav:false},600:{items:elemento.Elementos600,nav:false},800:{items:elemento.Elementos800,nav:false},1200:{items:elemento.Elementos1200,nav:false}}
                return opciones;
       },

        carruselAutoPlay:function(elemento){               
                var playAutomatico =  elemento.AutoPlay;
                 //console.log("playAutomatico  "+playAutomatico) 
                return playAutomatico;
       }
    },
    mounted() {
 //  console.log("contenidos ",this.contenidos)
    },
}
</script>

<style scoped>
.texto-descripcion{
  font-family: 'Myriad';
  font-size: 1.3em;
}
.caja-texto{
  background-color: white;
  border-radius: 10px;
  right: 0em;
  left: 0;
  padding: 2em;
  opacity: .85;
  position: absolute; 
   z-index: 1; 
   bottom:0px;
   text-align: justify;

}
.tituloCarrusel{
  margin-top: 1em;
  font-family: 'AntenaBeta';
   font-size: 2em;
   font-weight: bold;
}
.contenedor-imagenes{
   /* background-color:blue;  */
  margin:10px ;
  ;
  
}
.titulo{
   font-family: 'AntenaBeta';
   font-size: 1.5em;
   font-weight: bold;
}
.vinculo{
   font-family: 'AntenaBeta';
   font-size: 1.5em;
   font-weight: bold;
   color: blue;
   margin-right: 3em;
}
.imagenDeCarrusel{
 /* height: 30em;*/
  border-radius:2em ;
  box-shadow:  .2em .2em .9em .2em rgb(14, 13, 13);
  height: 45vh;
  /*height: 100%;
  width: 100%; */


     /* background-color:blue;  */
}

@media (max-width: 1700px) and (min-width: 0px) {
  .caja-texto{
    position:relative;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/CarruselSimple.vue